import Image from "@tiptap/extension-image";

export type ImageWidth = "25%" | "50%" | "75%" | "100%";
export type ImageAlign = "left" | "center" | "right";

export const CustomImage = Image.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      "data-width": {
        default: "100%",
        parseHTML: (element) => element.getAttribute("data-width") || "100%",
        renderHTML: (attributes) => ({
          "data-width": attributes["data-width"],
        }),
      },
      "data-align": {
        default: null,
        parseHTML: (element) => element.getAttribute("data-align"),
        renderHTML: (attributes) => {
          if (!attributes["data-align"]) return {};
          return { "data-align": attributes["data-align"] };
        },
      },
    };
  },
});
